// Service-worker registration for web push. The worker lives at the site root
// (/sw.js) so it controls the whole origin — a hard requirement for background
// push delivery.

let registrationPromise: Promise<ServiceWorkerRegistration> | null = null

// Register once and reuse the same promise. Callers can await this repeatedly
// (e.g. on every enable()) without stacking duplicate registrations.
export function registerServiceWorker(): Promise<ServiceWorkerRegistration> {
  if (!('serviceWorker' in navigator)) {
    return Promise.reject(new Error('Service workers are not supported in this browser'))
  }
  if (!registrationPromise) {
    registrationPromise = navigator.serviceWorker.register('/sw.js', { scope: '/' })
  }
  return registrationPromise
}

// Returns the active registration if one exists, else registers. `ready` resolves
// only once a worker is active, which is what pushManager needs.
export async function getReadyRegistration(): Promise<ServiceWorkerRegistration> {
  await registerServiceWorker()
  return navigator.serviceWorker.ready
}
